import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

const WareHouseDetails = ({ warehouse }) => {
  if (!warehouse) return <Typography>Select a warehouse to view details.</Typography>;

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">Warehouse: {warehouse.title}</Typography>
        <Typography>Facility Name: {warehouse.facility_name}</Typography>
        <Typography>Facility Type: {warehouse.facility_type}</Typography>
        <Typography>Notes: {warehouse.notes || "No notes available"}</Typography>
      </CardContent>
    </Card>
  );
};

export default WareHouseDetails;
